import React, { FC, Fragment, useMemo } from 'react';

import { useRoutesWithBreadcrumbs } from '../../context/BreadcrumbsContext';
import { Error404 } from '../ErrorPages';
import { AiPricingView } from './pages';

export const AiPricingEntrypoint: FC = () => {
  const routesConfig = useMemo(() => [
    {
      label: 'Cennik AI',
      element: <AiPricingView />,
      path: '/',
      index: true,
    },
    {
      path: '/*',
      element: <Error404 />,
    },
  ], []);

  const routes = useRoutesWithBreadcrumbs(routesConfig);

  return <Fragment key="routes">{routes}</Fragment>;
};
